import { withAuthenticationRequired } from '@auth0/auth0-react';
import ModuleDashboard from '@app/pages/dashboard/ModuleDashboard.tsx';
import DashboardV2 from '@app/pages/dashboard/v2/DashboardV2.tsx';
import LegacyVersionSwitch from '@components/framework/LegacyVersionSwitch.tsx';
import { BetaSurface } from '@hooks/useBetaVersion/betaSurfaces';
import Intro from '@app/layout/Intro.tsx';
import React from 'react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const IndexPage = () => {
  return (
    <ResponsiveLayout>
      <LegacyVersionSwitch surface={BetaSurface.DASHBOARD}>{showLegacy => (showLegacy ? <ModuleDashboard /> : <DashboardV2 />)}</LegacyVersionSwitch>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(IndexPage, {
  onRedirecting: () => <Intro />,
});
